// How long a live auction lot has left, for the Stock Alert actions list.
// Its own module so StockActionsPanel exports only a component (fast refresh).

/** "2h 15m left" / "3d left" / "ending now". Coarse on purpose: a list, not a clock. */
export const timeLeft = (endsAt, now = Date.now()) => {
  if (!endsAt) return null;
  const ms = new Date(endsAt).getTime() - now;
  if (Number.isNaN(ms)) return null;
  if (ms <= 60_000) return "ending now";
  const minutes = Math.floor(ms / 60_000);
  const days = Math.floor(minutes / 1440);
  if (days >= 1) return `${days}d left`;
  const hours = Math.floor(minutes / 60);
  return hours >= 1 ? `${hours}h ${minutes % 60}m left` : `${minutes}m left`;
};

export default timeLeft;
